const pad = (value: number) => String(value).padStart(2, '0');

export const formatOutOfWaterUntil = (until?: string | Date | null): string | null => {
  if (!until) return null;

  const date = until instanceof Date ? until : new Date(until);
  if (Number.isNaN(date.getTime())) return null;

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  const year = date.getFullYear();
  const thisYear = new Date().getFullYear();

  return year === thisYear
    ? `${day}.${month} ${time}`
    : `${day}.${month}.${pad(year % 100)} ${time}`;
};
